import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import logo from '../images/LamarLogo.png';
import SubscribeForm from './SubscribeForm/SubscribeForm';
import styled, {css} from 'styled-components';
import Container from '@material-ui/core/Container';
import { Link } from 'gatsby';
import colors from '../styles/colors';
import { device } from '../styles/media';


const Credit = styled.p`
    color: white;
    text-align: center;
`

const MyLink = styled.a`
    color: ${colors.secondary};
    text-decoration: none;
    transition: 0.5s;

    &:hover{
        color: white;
    }
`

const StyledButton = styled(Link)`
    border-radius: 25px;
    padding 0.6rem 2.0rem;
    text-decoration: none;
    color: white;
    margin: auto 0.5rem;
    background-color: ${colors.secondary};
    display: inline-block;
    transition: 0.5s;

    :hover{
        color: black;
        background-color: white;
    }
    
    ${props => props.secondary && css`
        background-color: transparent;
        border: 1px solid white;
        @media ${device.xs}{
            display: block;
            margin-top: 0.8rem;
            padding: 0.5rem;
            width: auto;
        }

        :hover{
            background-color: ${colors.primaryLight};
            border: none;
            color: white;
        }
    `}
`
const StyledContainer = styled(Container)`
        padding-bottom: 2rem;
`
const StyledGridItem = styled(Grid)`
    line-height: 35px;
    height: auto;
    max-height: 600px;
    color: white;
    padding-top: 5.0rem;
    ${props => props.bottom && css`
        text-align: center;
        padding-bottom: 2rem;
        @media ${device.mobile}{
            padding-bottom: 0;
        }
    `}

    @media ${device.tablet}{
        ${props => props.upper_right && css`
            padding-top: 0;
            @media ${device.xs}{
                padding-top: 0 !important;
            }
        `}
        ${props => props.bottom && css`
        padding-top: 0;
        `}
        ${props => props.top && css`
            text-align: center;
            @media ${device.xs}{
                padding-top: 2rem;
                box-sizing: border-box;
            }
        `}
`
const StyledH2 = styled.h2`
    margin: 0;
`
const StyledImg = styled.img`
    max-width: 4rem;
    max-height: 4rem;
`
const StyledLink = styled(Link)`
    text-decoration: none;
    color: white;
    transition: 0.25s;

    :hover{
        color: ${colors.secondary};
    }
`
const MainShape = styled(Grid)`
    width: 100vw;
    height: auto;
    min-height: 750px;
    background-color: black;
    margin: 0;
    border-top-right-radius: 8rem;
    background-image: linear-gradient(${colors.footerLight}, ${colors.primaryDark});
`
const StyledP = styled.p`
    color: ${colors.textLight};
    margin-top: 0.5rem;
`
const SocialLink = styled.a`
    color: white;
    padding: 1rem;
    transition: 0.25s;

    :hover{
        color: ${colors.secondary};
    }
`
const StyledGrid = styled(Grid)`
    
`



const Footer = () => {
    return (
        <StyledGrid container>
            <MainShape item xl={11} lg={12}>
                <Container>
                    <Grid container>        
                        <StyledGridItem item md={6} sm={12} top='true'>
                            <StyledContainer>
                                <StyledH2>Subscribe to Get Notified</StyledH2>
                                <StyledP>
                                    Our newsletter covers the latest trends and technology. 
                                </StyledP>
                                <SubscribeForm />  
                            </StyledContainer>   
                        </StyledGridItem>
                        <StyledGridItem item md={6} sm={12} upper_right='true' top='true'>
                            <StyledContainer>
                                <StyledH2>Surprisingly, we're human.</StyledH2>
                                <StyledP>
                                    And understanding your business needs are important to us. 
                                    Email us to schedule an appointment or call us directly; we'd be happy to talk.
                                </StyledP>
                            </StyledContainer>
                        </StyledGridItem>
                    </Grid>
                    <Divider light/>
                    <Grid container>
                        <StyledGridItem bottom='true' item md={3} sm={6} xs={12}>
                            <StyledContainer maxWidth='sm'>
                                <StyledImg src={logo} alt='LaMar Software Logo'/>
                                <StyledP>
                                    LaMar Software
                                    <br />
                                    Tailored enterprise software that scales as you scale.
                                </StyledP>   
                            </StyledContainer>
                        </StyledGridItem>
                        <StyledGridItem bottom='true' item md={3} sm={6} xs={12}>
                            <h2>About</h2>
                            <StyledLink to='/about#whyus'>Why Us</StyledLink><br />
                            <StyledLink to='/about#ourteam'>Our Team</StyledLink><br />
                            <StyledLink to='/about#clients'>Clients</StyledLink>
                        </StyledGridItem>
                        <StyledGridItem bottom='true' item md={3} sm={6} xs={12}>
                            <h2>Contact</h2>
                            <StyledLink to='/contact#location'>Location</StyledLink><br />
                            <StyledLink to='/contact#message'>Message Us</StyledLink><br />
                        </StyledGridItem>
                        <StyledGridItem bottom='true' item md={3} sm={6} xs={12}>
                            <h2>
                                <SocialLink target='_blank' href='https://www.facebook.com/taylorlamarconsulting' aria-label='Link to Facebook page'><FontAwesomeIcon icon={faFacebookF} aria-hidden="true"/></SocialLink>
                                <SocialLink target='_blank' href='https://www.instagram.com/taylor.lamar.consulting/' aria-label='Link to Instagram page'><FontAwesomeIcon icon={faInstagram} aria-hidden="true"/></SocialLink>
                                <SocialLink target='_blank' href='https://www.linkedin.com/company/taylor-lamar-consulting/' aria-label='Link to LinkedIn Page'><FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true"/></SocialLink>
                            </h2>
                            <StyledP>contact@taylorlamar.com</StyledP>
                            <StyledP>209 - 322 - 7884</StyledP>
                        </StyledGridItem>     
                    </Grid>
                    <Divider />
                    <Credit>
                       2019 XO <MyLink target='_blank' href='https://www.chrisycho.com'>Chris Cho</MyLink>
                    </Credit>
                </Container>
                    
            </MainShape>
            <Grid item xl={1}></Grid>
        </StyledGrid>
        
    )
}

export default Footer;